import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";

// Admin Pages
import AdminDashboard from "./pages/admin/Dashboard";

import AdminShipments from "./pages/admin/Shipments";
import AdminShipment from "./pages/admin/Shipment";
import AdminCreateShipment from "./pages/admin/CreateShipment";
import AdminEditShipment from "./pages/admin/EditShipment";

import AdminDiscountsPromos from "./pages/admin/DiscountsPromos";
import AdminCreateDiscount from "./pages/admin/CreateDiscount";
import AdminCreatePromoCode from "./pages/admin/CreatePromoCode";
import AdminDiscount from "./pages/admin/Discount";
import AdminPromoCode from "./pages/admin/PromoCode";

import AdminCustomers from "./pages/admin/Customers";
import AdminCustomer from "./pages/admin/Customer";
import AdminEditCustomer from "./pages/admin/EditCustomer";
import AdminAddCustomer from "./pages/admin/AddCustomer";

import AdminTeamList from "./pages/admin/TeamList";
import AdminTeam from "./pages/admin/Team";
import AdminEditTeam from "./pages/admin/EditTeam";
import AdminAddTeam from "./pages/admin/AddTeam";

import AdminAnalytics from "./pages/admin/Analytics";
import AdminSettings from "./pages/admin/Settings";
import AdminSearchResults from "./pages/admin/SearchResults";

// Customer Pages
import CustomerDashboard from "./pages/customer/Dashboard";
import CustomerShipments from "./pages/customer/Shipments";
import CustomerShipment from "./pages/customer/Shipment";
import CustomerProfile from "./pages/customer/Profile";
import AdminLayout from "./components/layouts/AdminLayout";

const withAdminLayout = (children: React.ReactNode) => {
  return <AdminLayout>{children}</AdminLayout>;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/login" element={<LoginPage />} />

      {/* Admin Routes */}
      <Route
        path="/admin/dashboard"
        element={withAdminLayout(<AdminDashboard />)}
      />

      <Route
        path="/admin/shipments"
        element={withAdminLayout(<AdminShipments />)}
      />
      <Route
        path="/admin/shipments/new"
        element={withAdminLayout(<AdminCreateShipment />)}
      />
      <Route
        path="/admin/shipments/:trackingNumber"
        element={withAdminLayout(<AdminShipment />)}
      />
      <Route
        path="/admin/shipments/:trackingNumber/edit"
        element={withAdminLayout(<AdminEditShipment />)}
      />

      <Route
        path="/admin/discounts-promos"
        element={withAdminLayout(<AdminDiscountsPromos />)}
      />
      <Route
        path="/admin/discounts/new"
        element={withAdminLayout(<AdminCreateDiscount />)}
      />
      <Route
        path="/admin/promos/new"
        element={withAdminLayout(<AdminCreatePromoCode />)}
      />
      <Route
        path="/admin/discounts/:id"
        element={withAdminLayout(<AdminDiscount />)}
      />
      <Route
        path="/admin/promos/:id"
        element={withAdminLayout(<AdminPromoCode />)}
      />

      <Route
        path="/admin/customers"
        element={withAdminLayout(<AdminCustomers />)}
      />
      <Route
        path="/admin/customers/new"
        element={withAdminLayout(<AdminAddCustomer />)}
      />
      <Route
        path="/admin/customers/:customerId"
        element={withAdminLayout(<AdminCustomer />)}
      />
      <Route
        path="/admin/customers/:customerId/edit"
        element={withAdminLayout(<AdminEditCustomer />)}
      />

      <Route path="/admin/team" element={withAdminLayout(<AdminTeamList />)} />
      <Route
        path="/admin/team/new"
        element={withAdminLayout(<AdminAddTeam />)}
      />
      <Route
        path="/admin/team/:teamId"
        element={withAdminLayout(<AdminTeam />)}
      />
      <Route
        path="/admin/team/:teamId/edit"
        element={withAdminLayout(<AdminEditTeam />)}
      />

      <Route
        path="/admin/analytics"
        element={withAdminLayout(<AdminAnalytics />)}
      />
      <Route
        path="/admin/settings"
        element={withAdminLayout(<AdminSettings />)}
      />
      <Route
        path="/admin/search"
        element={withAdminLayout(<AdminSearchResults />)}
      />

      {/* Customer Routes */}
      <Route path="/dashboard" element={<CustomerDashboard />} />
      <Route path="/shipments" element={<CustomerShipments />} />
      <Route path="/shipments/:trackingNumber" element={<CustomerShipment />} />
      <Route path="/profile" element={<CustomerProfile />} />
    </Routes>
  );
}

export default App;
